/*
 * This file was automatically generated. Do not make any changes
 * directly as they may be overwritten.
 *
 * To update this file, run `yarn run generate-api`.
 */
import { apiService } from "assets/scripts/domain/apiService";
/* tslint:disable */
export const ADD_URL = "/api/accounts/add";
export const ADD_PROBATE_CASE_URL = "/api/accounts/probate-case";
export const CHECK_QUICK_PAY_AMOUNT_URL = "/api/accounts/quickPay/checkAmount";
export const CONFIRM_URL = "/api/accounts/confirm";
export const CONFIRM_VALIDATION_URL = "/api/accounts/confirm-validation";
export const EMAIL_OPT_OUT_PUBLIC_URL = "/api/accounts/emailOptOut";
export const EMAIL_OPT_OUT_SECURE_URL = "/api/accounts/emailOptOutSecure";
export const FIND_URL = "/api/accounts/find";
export const GET_EMAIL_OPT_OUTS_SECURE_URL = "/api/accounts/getEmailOptOutsSecure";
export const GET_QUICK_PAY_TOKEN_URL = "/api/accounts/quickPay/getToken";
export const LOGIN_URL = "/api/accounts/login";
export const LOGOUT_URL = "/api/accounts/logout";
export const NEW_ACCOUNT_URL = "/api/accounts/new";
export const QUICK_PAY_URL = "/api/accounts/quickPay";
export const RIGHT_PARTY_CONTACT_URL = "/api/accounts/rpc";
export const SETUP_SESSION_URL = "/api/accounts/newsession";
export const SIGN_UP_URL = "/api/accounts/signup";
export const SIGN_UP_TOKEN_URL = "/api/accounts/signupToken";
export const UPDATE_URL = "/api/accounts/update";
export function add(model) {
    return apiService.post(ADD_URL, true, {
        model
    });
}
export function addProbateCase(payableId, model) {
    return apiService.post(ADD_PROBATE_CASE_URL, true, {
        payableId,
        model
    });
}
export function checkQuickPayAmount(token, amount) {
    return apiService.post(CHECK_QUICK_PAY_AMOUNT_URL, false, {
        token,
        amount
    });
}
export function confirm(model) {
    return apiService.post(CONFIRM_URL, false, {
        model
    });
}
export function confirmValidation(model) {
    return apiService.post(CONFIRM_VALIDATION_URL, false, {
        model
    });
}
export function emailOptOutPublic(token) {
    return apiService.post(EMAIL_OPT_OUT_PUBLIC_URL, false, {
        token
    });
}
export function emailOptOutSecure(refNums) {
    return apiService.post(EMAIL_OPT_OUT_SECURE_URL, true, {
        refNums
    });
}
export function find(referenceNumber, pin) {
    return apiService.post(FIND_URL, true, {
        referenceNumber,
        pin
    });
}
export function getEmailOptOutsSecure() {
    return apiService.post(GET_EMAIL_OPT_OUTS_SECURE_URL, true, {});
}
export function getQuickPayToken(referenceNumber, pin, channel) {
    return apiService.post(GET_QUICK_PAY_TOKEN_URL, false, {
        referenceNumber,
        pin,
        channel
    });
}
export function login(model) {
    return apiService.post(LOGIN_URL, false, {
        model
    });
}
export function logout() {
    return apiService.post(LOGOUT_URL, true, {});
}
export function newAccount(model) {
    return apiService.post(NEW_ACCOUNT_URL, false, {
        model
    });
}
export function quickPay(token) {
    return apiService.post(QUICK_PAY_URL, false, {
        token
    });
}
export function rightPartyContact(model) {
    return apiService.post(RIGHT_PARTY_CONTACT_URL, false, {
        model
    });
}
export function setupSession() {
    return apiService.post(SETUP_SESSION_URL, true, {});
}
export function signUp(model) {
    return apiService.post(SIGN_UP_URL, false, {
        model
    });
}
export function signUpToken(token, captchaResponse) {
    return apiService.post(SIGN_UP_TOKEN_URL, false, {
        token,
        captchaResponse
    });
}
export function update(model) {
    return apiService.post(UPDATE_URL, true, {
        model
    });
}
/* tslint:enable */ 



// WEBPACK FOOTER //
// ./src/generated/api/accounts.ts